import { useTrendMini } from '../../demo/selectors'
import { Card, CardHead } from '../../ui'
import { toFixed1HalfEven } from './overview'
import styles from './TrendMiniCard.module.css'

const WIDTH = 660
const HEIGHT = 250
const PADDING_LEFT = 52
const PADDING_RIGHT = 46
const PADDING_TOP = 30
const PADDING_BOTTOM = 26
const INNER_WIDTH = WIDTH - PADDING_LEFT - PADDING_RIGHT
const INNER_HEIGHT = HEIGHT - PADDING_TOP - PADDING_BOTTOM
const SPEND_MAX = 4000
const ROAS_MAX = 5
const DIVISIONS = 4

function x(index: number, count: number): number {
  return PADDING_LEFT + INNER_WIDTH * index / (count - 1)
}

function y(value: number, max: number): number {
  return PADDING_TOP + INNER_HEIGHT - INNER_HEIGHT * (value / max)
}

function gridY(index: number): number {
  return PADDING_TOP + INNER_HEIGHT - INNER_HEIGHT * index / DIVISIONS
}

function linePath(values: number[], max: number): string {
  return values.map((value, index) => `${index === 0 ? 'M' : 'L'}${x(index, values.length).toFixed(1)} ${y(value, max).toFixed(1)}`).join(' ')
}

export function TrendMiniCard() {
  const trend = useTrendMini()
  const spendPath = linePath(trend.spend, SPEND_MAX)
  const roasPath = linePath(trend.roas, ROAS_MAX)
  const lastX = x(trend.days.length - 1, trend.days.length).toFixed(1)
  const firstX = x(0, trend.days.length).toFixed(1)

  return (
    <Card data-scope="overview-trend">
      <CardHead
        title="广告表现总览"
        action={(
          <div className={styles.legend}>
            <span><i className={styles.spendLegend} />消耗金额</span>
            <span><i className={styles.roasLegend} />ROAS</span>
            <span className={styles.range}>{trend.rangeLabel}</span>
          </div>
        )}
      />
      <div className={styles.body}>
        <svg width="100%" viewBox={`0 0 ${WIDTH} ${HEIGHT}`} role="img" aria-label="近 7 天消耗金额与 ROAS 趋势">
          <defs>
            <linearGradient id="g" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stopColor="#0866FF" stopOpacity=".16" />
              <stop offset="1" stopColor="#0866FF" stopOpacity="0" />
            </linearGradient>
          </defs>
          {Array.from({ length: DIVISIONS + 1 }, (_, index) => (
            <line key={`grid-${index}`} x1="52" y1={gridY(index).toFixed(1)} x2="614" y2={gridY(index).toFixed(1)} stroke="#EBEEF1" />
          ))}
          <path d={`${spendPath} L${lastX} 224 L${firstX} 224 Z`} fill="url(#g)" />
          <path d={spendPath} fill="none" stroke="#0866FF" strokeWidth="2.2" strokeLinejoin="round" />
          <path d={roasPath} fill="none" stroke="#0A8A43" strokeWidth="2.2" strokeLinejoin="round" />
          {trend.roas.map((value, index) => (
            <circle key={`point-${trend.days[index]}`} cx={x(index, trend.days.length).toFixed(1)} cy={y(value, ROAS_MAX).toFixed(1)} r="3" fill="#fff" stroke="#0A8A43" strokeWidth="2" />
          ))}
          {Array.from({ length: DIVISIONS + 1 }, (_, index) => (
            <text key={`left-${index}`} x="42" y={(gridY(index) + 4).toFixed(1)} textAnchor="end" fontSize="11" fill="#8A8D91">${index}K</text>
          ))}
          {Array.from({ length: DIVISIONS + 1 }, (_, index) => (
            <text key={`right-${index}`} x="624" y={(gridY(index) + 4).toFixed(1)} fontSize="11" fill="#8A8D91">{toFixed1HalfEven(ROAS_MAX * index / DIVISIONS)}</text>
          ))}
          {trend.days.map((day, index) => (
            <text key={day} x={x(index, trend.days.length).toFixed(1)} y="244" textAnchor="middle" fontSize="11" fill="#8A8D91">{day}</text>
          ))}
          <text x="42" y="12" textAnchor="end" fontSize="11" fill="#0866FF">消耗金额</text>
          <text x="624" y="12" fontSize="11" fill="#0A8A43">ROAS</text>
        </svg>
      </div>
    </Card>
  )
}
